/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { TrelloStorage } from '@trello/storage';

import { filterByKeys, sort } from 'app/scripts/lib/limits';
import { Util } from 'app/scripts/lib/util';
import { BoardHeaderWarningsTemplate } from 'app/scripts/views/templates/BoardHeaderWarningsTemplate';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderBoardWarnings = function (this: any) {
  // eslint-disable-next-line @trello/enforce-variable-case
  const $warnings = $('.js-board-warnings', this.$el);

  const perBoardLimits = sort(
    filterByKeys(this.model.get('limits'), [
      'cards.openPerBoard',
      'cards.totalPerBoard',
      'checklists.perBoard',
      'labels.perBoard',
      'lists.openPerBoard',
      'lists.totalPerBoard',
      'attachments.perBoard',
    ]).filter((l) => l.status !== 'ok'),
  );
  const templateMap = {
    'cards.openPerBoard': 'open-cards-per-board-limit',
    'cards.totalPerBoard': 'total-cards-per-board-limit',
    'checklists.perBoard': 'checklists-per-board-limit',
    'labels.perBoard': 'labels-per-board-limit',
    'lists.openPerBoard': 'open-lists-per-board-limit',
    'lists.totalPerBoard': 'total-lists-per-board-limit',
    'attachments.perBoard': 'attachments-per-board-limit',
  };
  const isEditable = this.model.editable();
  const minDismiss = Util.dateBefore({ months: 6 });
  const warnings = perBoardLimits.map(function (limit) {
    const name = limit.key;
    const status = limit.status === 'warn' ? 'warn' : 'disabled';
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const key = `${templateMap[limit.key]}-${status}`;
    const test = () => isEditable;
    return [name, { key, test, minDismiss }];
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dismissWarningName = (name: any) => {
    return `BoardWarning-${name}-${this.model.id}`;
  };

  const warning = _.chain(warnings)
    // @ts-expect-error TS(2345): Argument of type '(value: (string | { key: string;... Remove this comment to see the full error message
    .filter(function (...args) {
      // @ts-expect-error TS(2339): Property 'test' does not exist on type 'string | {... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const [name, { test, minDismiss }] = Array.from(args[0]);
      if (test()) {
        const dismissed = TrelloStorage.get(dismissWarningName(name));
        return !dismissed || dismissed < minDismiss;
      }
    })
    .map(function (...args) {
      // @ts-expect-error TS(2339): Property 'key' does not exist on type 'string | { ... Remove this comment to see the full error message
      const [name, { key }] = Array.from(args[0]);
      return { name, key, dismiss: dismissWarningName(name) };
    })
    .first()
    .value();

  _.chain(warnings)
    .filter(function (...args) {
      // @ts-expect-error TS(2339): Property 'test' does not exist on type 'string | {... Remove this comment to see the full error message
      const [name, { test }] = Array.from(args[0]);
      return !test() && TrelloStorage.get(dismissWarningName(name)) != null;
    })
    .each(function (...args) {
      const [name] = Array.from(args[0]);
      return TrelloStorage.unset(dismissWarningName(name));
    })
    .value();

  if (warning) {
    $warnings.removeClass('hide').html(
      BoardHeaderWarningsTemplate({
        canDismiss: TrelloStorage.isEnabled(),
        warning,
      }),
    );
  } else {
    $warnings.addClass('hide');
  }

  return this;
};
